import React, { useState } from 'react';
import siteLogo from '../images/sitelogo.png';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle subscription logic here
    console.log('Email submitted:', email);
    setEmail('');
    // You could add a success message or toast notification here
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-hackGreen-100 py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-10">
          {/* Logo section */}
          <div className="mb-8 lg:mb-0">
            <a href="https://disabilityhackshub.com/">
              <img 
                src={siteLogo} 
                alt="Disability Hacks Hub Logo" 
                style={{ height: '44px', width: 'auto' }}
              />
            </a>
          </div>
          
          {/* Navigation links */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 mb-8 lg:mb-0">
            <div>
              {/* <a 
                href="https://disabilityhackshub.com/community/" 
                className="text-gray-800 hover:text-hackGreen-600 block mb-4"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Community Hacks
              </a> */}
              <a 
                href="https://disabilityhackshub.com/submit/" 
                className="text-gray-800 hover:text-hackGreen-600 block mb-4"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Submit Hack
              </a>
              <a 
                href="https://disabilityhackshub.netlify.app/" 
                className="text-gray-800 hover:text-hackGreen-600 block mb-4"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Browse Hacks
              </a>
            </div>
            <div>
              <a 
                href="https://disabilityhackshub.com/contact/" 
                className="text-gray-800 hover:text-hackGreen-600 block"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Contact
              </a>
            </div>
            {/* Add more columns/links here if needed */}
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
          {/* Legal links */}
          <div className="flex flex-wrap gap-4 mb-4 md:mb-0">
            <a 
              href="https://disabilityhackshub.com/privacy-policy/" 
              className="text-sm text-gray-600 hover:text-hackGreen-600"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Privacy Policy
            </a>
            <a 
              href="https://disabilityhackshub.com/terms-of-service/" 
              className="text-sm text-gray-600 hover:text-hackGreen-600"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Terms of Service
            </a>
            <a 
              href="https://disabilityhackshub.com/cookies-settings/" 
              className="text-sm text-gray-600 hover:text-hackGreen-600"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Cookies Settings
            </a>
          </div>

          {/* Copyright text */}
          <p className="text-sm text-gray-600" style={{ fontFamily: 'Manrope, sans-serif' }}>
            © {currentYear} Disability Hacks Hub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
